module.exports = __webpack_public_path__ + "img/ukey.c20e7e4d.png";